import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import Table from 'react-bootstrap/Table';
import Button from 'react-bootstrap/Button';
import { useNavigate } from 'react-router-dom';
import { app } from '../firebase';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import Spinner from 'react-bootstrap/Spinner';
import { initializeApp as initializeSecondaryApp, deleteApp } from 'firebase/app';
import { getAuth, createUserWithEmailAndPassword } from 'firebase/auth';
import { getFirestore, collection, orderBy, query, getDocs, addDoc, Timestamp, doc, updateDoc, deleteDoc } from 'firebase/firestore';

function DriversComp() {
  const [driversList, setDriversList] = useState([]);
  const [vehiclesList, setVehiclesList] = useState([]);
  const db = getFirestore(app);
  const navigate = useNavigate();

  const [searchTerm, setSearchTerm] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [formData, setFormData] = useState({ full_name: '', email: '', password: '', userType: '', city: '', userphone: '', assignedVehicle: '', active: true });
  const [editData, setEditData] = useState({});
  const [loading, setLoading] = useState(false);
  const [deletingId, setDeletingId] = useState(null);

  // Fetch drivers and vehicles
  useEffect(() => {
    const fetchData = async () => {
      const driversSnap = await getDocs(collection(db, 'drivers'));
      const drivers = [];
      driversSnap.forEach(doc => drivers.push({ id: doc.id, ...doc.data() }));
      setDriversList(drivers);

      const vehiclesSnap = await getDocs(collection(db, 'vehicles'));
      const vehicles = [];
      vehiclesSnap.forEach(doc => vehicles.push({ id: doc.id, ...doc.data() }));
      setVehiclesList(vehicles);
    };
    fetchData();
  }, [db]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleEditChange = (e) => {
    setEditData({ ...editData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const secondaryApp = initializeSecondaryApp(app.options, `secondary-${Date.now()}`);
      const secondaryAuth = getAuth(secondaryApp);

      const userCredential = await createUserWithEmailAndPassword(
        secondaryAuth,
        formData.email,
        formData.password
      );

      const uid = userCredential.user.uid;

      await addDoc(collection(db, 'drivers'), {
        uid,
        ...formData,
        signupdate: Timestamp.now(),
        lastTimeLocationUpdate: Timestamp.now()
      });

      setFormData({ full_name: '', email: '', password: '', userType: '', city: '', userphone: '', assignedVehicle: '', active: true });
      setShowModal(false);

      const snapshot = await getDocs(query(collection(db, 'drivers'), orderBy('signupdate', 'desc')));
      const drivers = [];
      snapshot.forEach(doc => drivers.push({ id: doc.id, ...doc.data() }));
      setDriversList(drivers);

      await deleteApp(secondaryApp);
      alert('Driver added successfully');
    } catch (error) {
      console.error('Error adding driver:', error);
      alert(error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = async (e) => {
    e.preventDefault();
    try {
      const driverRef = doc(db, 'drivers', editData.id);
      await updateDoc(driverRef, {
        full_name: editData.full_name,
        userphone: editData.userphone,
        assignedVehicle: editData.assignedVehicle
      });
      alert('Driver updated successfully');
      setEditModal(false);

      const snapshot = await getDocs(collection(db, 'drivers'));
      const drivers = [];
      snapshot.forEach(doc => drivers.push({ id: doc.id, ...doc.data() }));
      setDriversList(drivers);
    } catch (error) {
      console.error('Error updating driver:', error);
    }
  };

  const handleDeactivate = async (driverId, currentStatus) => {
    try {
      const driverRef = doc(db, 'drivers', driverId);
      await updateDoc(driverRef, { active: !currentStatus });
      alert(`Driver ${currentStatus ? 'deactivated' : 'activated'} successfully`);
      const snapshot = await getDocs(collection(db, 'drivers'));
      const drivers = [];
      snapshot.forEach(doc => drivers.push({ id: doc.id, ...doc.data() }));
      setDriversList(drivers);
    } catch (error) {
      console.error('Error deactivating driver:', error);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this driver?')) return;
    setDeletingId(id);
    try {
      await deleteDoc(doc(db, 'drivers', id));
      setDriversList(driversList.filter(driver => driver.id !== id));
      alert('Driver deleted successfully');
    } catch (error) {
      console.error('Error deleting driver:', error);
    } finally {
      setDeletingId(null);
    }
  };

  const normalizedSearch = searchTerm.trim().toLowerCase();
  const filteredDrivers = driversList.filter((driver) => {
    if (!normalizedSearch) return true;
    const values = [
      driver.full_name,
      driver.userphone,
      driver.assignedVehicle,
      driver.city,
      driver.userType,
      driver.active ? 'active' : 'inactive'
    ];
    return values.some((value) =>
      String(value || '').toLowerCase().includes(normalizedSearch)
    );
  });

  return (
    <div className="dataComp">
      <div className="dataCompTop d-flex justify-content-between align-items-center mb-3">
        <h5>All Drivers</h5>
        <div className="searchContainer d-flex align-items-center gap-2">
          <FontAwesomeIcon icon={faSearch} className="searchIcon" />
          <input
            type="text"
            placeholder="Type to search"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <button onClick={() => setShowModal(true)}>Add a Driver</button>
        </div>
      </div>

      <Table striped bordered hover responsive>
        <thead>
          <tr>
            <th>Full Name</th>
            <th>Phone</th>
            <th>Assigned Vehicle</th>
            <th>Sign Up</th>
            <th>Last Active</th>
            <th>Edit</th>
            <th>Deactivate</th>
            <th>Delete</th>
            <th>Track</th>
            
            <th>View Trips</th>
          </tr>
        </thead>
        <tbody>
          {filteredDrivers.map(driver => (
            <tr key={driver.id}>
              <td>{driver.full_name}</td> 
              <td>{driver.userphone}</td>
              <td>{driver.assignedVehicle || 'None'}</td>
              <td>{driver.signupdate?.toDate().toLocaleString() || 'NA'}</td>
              <td>{driver.lastActiveTime?.toDate().toLocaleString()}</td>
              <td>
                <Button size="sm" variant="info" onClick={() => { setEditData(driver); setEditModal(true); }}>
                  Edit
                </Button>
              </td>
              <td>
                <Button
                  size="sm"
                  variant={driver.active ? 'secondary' : 'success'}
                  onClick={() => handleDeactivate(driver.id, driver.active)}
                >
                  {driver.active ? 'Deactivate' : 'Activate'}
                </Button>
              </td>
              <td>
                <Button
                  size="sm"
                  variant="danger"
                  onClick={() => handleDelete(driver.id)}
                  disabled={deletingId === driver.id}
                >
                  {deletingId === driver.id ? (
                    <Spinner as="span" animation="border" size="sm" />
                  ) : 'Delete'}
                </Button>
              </td>
              <td>
                <Button size="sm" variant="success" onClick={() => navigate(`/track-driver/${driver.uid}`)}>Track</Button>
              </td>
              <td>
                <Button size="sm" variant="warning" onClick={() => navigate(`/driver-trips/${driver.id}`)}>View Trips</Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      {/* Add Driver Modal */}
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Add New Driver</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3">
              <Form.Label>Full Name</Form.Label>
              <Form.Control name="full_name" value={formData.full_name} onChange={handleChange} required />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Email</Form.Label>
              <Form.Control type="email" name="email" value={formData.email} onChange={handleChange} required />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Password</Form.Label>
              <Form.Control type="password" name="password" value={formData.password} onChange={handleChange} required />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Phone</Form.Label>
              <Form.Control name="userphone" value={formData.userphone} onChange={handleChange} required />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Driver Type</Form.Label>
              <Form.Control name="userType" value={formData.userType} onChange={handleChange} />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>City</Form.Label>
              <Form.Control name="city" value={formData.city} onChange={handleChange} />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Assign Vehicle</Form.Label>
              <Form.Select name="assignedVehicle" value={formData.assignedVehicle} onChange={handleChange}>
                <option value="">Select Vehicle</option>
                {vehiclesList.map(vehicle => (
                  <option key={vehicle.id} value={vehicle.vehicleReg}>{vehicle.vehicleReg}</option>
                ))}
              </Form.Select>
            </Form.Group>
            <Button type="submit" disabled={loading}>
              {loading ? <Spinner as="span" animation="border" size="sm" /> : 'Save Driver'}
            </Button>
          </Form>
        </Modal.Body>
      </Modal>

      {/* Edit Driver Modal */}
      <Modal show={editModal} onHide={() => setEditModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Edit Driver</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleEdit}>
            <Form.Group className="mb-3">
              <Form.Label>Full Name</Form.Label>
              <Form.Control name="full_name" value={editData.full_name || ''} onChange={handleEditChange} required />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Phone</Form.Label>
              <Form.Control name="userphone" value={editData.userphone || ''} onChange={handleEditChange} required />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Assign Vehicle</Form.Label>
              <Form.Select name="assignedVehicle" value={editData.assignedVehicle || ''} onChange={handleEditChange}>
                <option value="">Select Vehicle</option>
                {vehiclesList.map(vehicle => (
                  <option key={vehicle.id} value={vehicle.vehicleReg}>{vehicle.vehicleReg}</option>
                ))}
              </Form.Select>
            </Form.Group>
            <Button type="submit">Update Driver</Button>
          </Form>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default DriversComp;
